import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {roomMeetingNoteService} from "@/core/service/room.meetingNote.service";
import _ from 'lodash'
import { RoomInfo } from '@/core/api/room.info.api'

class RoomMeetingNoteApi extends BaseApi {
    #roomMeetingNoteList

    constructor() {
        super();
        Room.MeetingNote = this;

        Room.ready(async () => {
            if(!RoomInfo.useModule('meetingNote')){
                return;
            }

            this._eventListen(this.#Events);

            this.#roomMeetingNoteList = await this.getMeetingNoteList();
            Room.emit({
                type: 'room_meetingNote_init',
                data: _.cloneDeep(this.#roomMeetingNoteList),
            })
        });
    }

    async getMeetingNoteList() {
        let {data = []} = await roomMeetingNoteService.getMeetingNoteList();
        return data;
    }

    async startMeetingNote(data) {
        return await roomMeetingNoteService.startMeetingNote(data);
    }

    async stopMeetingNote(data) {
        return await roomMeetingNoteService.stopMeetingNote(data);
    }

    async deleteMeetingNote(data) {
        return await roomMeetingNoteService.deleteMeetingNote(data);
    }

    async summarizeMeetingNote(data) {
        return await roomMeetingNoteService.summarizeMeetingNote(data);
    }

    async getMeetingNote({meetingNoteId}) {
        return (await roomMeetingNoteService.getMeetingNote({meetingNoteId})).data;
    }

    async getMeetingNoteSummary({meetingNoteId}) {
        return (await roomMeetingNoteService.getMeetingNoteSummary({meetingNoteId})).data;
    }

    #Events = {
        start_meeting_note: function (e) {
            Room.emit(e);
        },
        stop_meeting_note: function (e) {
            Room.emit(e);
        },
        delete_meeting_note: function (e) {
            Room.emit(e);
        },
        start_meeting_note_summary: function (e) {
            Room.emit(e);
        },
        completed_meeting_note_summary: function (e) {
            Room.emit(e);
        },
        failed_meeting_note_summary: function (e) {
            Room.emit(e);
        },
    };
}

export const roomMeetingNoteApi = new RoomMeetingNoteApi();